import { Component, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikIgangvaerende } from '../../models/StatistikIgangvaerende';
import { StatistikNormPlantidModalViewModel } from '../../models/StatistikNormPlantidModalViewModel';

@Component({
    selector: 'app-statistik-norm-timebudget-modal-ui',
    templateUrl: './statistik-norm-timebudget-modal.html',
    styleUrls: ['./statistik-norm-timebudget-modal.scss'],
    standalone: false
})
export class StatistikNormTimebudgetModal {
    @Output() kunde: StatistikIgangvaerende;
    @Output() date: any;
    year: string;
    month: number;
    plantid: StatistikNormPlantidModalViewModel[];

    constructor(
        private activeModal: NgbActiveModal,
    ) { }

    onDismiss() {
        this.activeModal.dismiss();
    }

    hoursTotal() {
        let Total = 0;
        this.plantid.forEach(element => {
            Total += element.timer;
        });
        return Math.round(Total);
    }
}
